const initialState = {
  input: "",
};

const notes = (state = initialState, action: any) => {
  switch (action.type) {
    case "HANDLE_NOTES_CHANGE":
      return {
        ...state,
        input: action.payload,
      };
    default:
      return state;
  }
};

export default notes;
